import React, { useEffect, useState } from "react";
import { useTable, useSortBy, usePagination } from "react-table";
import { PrevBtn, NextBtn, PaginationWrapper, UserImage } from "../Styles/PageStyles";
import Images from "../../Images";
import tw from "tailwind-styled-components";
import Config, { PaginationLimit } from "../../Config";
import { truncateText, capitalizeFirstLetter, handleCopy } from "../../helpers";
import Tooltip from "../Tooltip";
import { MdEdit } from "react-icons/md";

import {
    FaFileAlt,
} from "react-icons/fa";
import { FiEdit3 } from "react-icons/fi";
import { IoCopySharp } from "react-icons/io5";
import { useNavigate } from "react-router-dom";

const ClosedTable = ({
    apiData,
    activeTab,
    setIsEditDeal,
    setSelectedData,
    setIsEditBasicInfo,
    setIsViewNotes,
}) => {

    const editDeal = (item) => {
        setIsEditDeal(true);
        setSelectedData(item);
        setOpenActionMenu(null);
    }

    const navigate = useNavigate();

    const editBasicInfo = (item) => {
        const isActiveLease = item.status === Config.DEAL_STATUS.ACTIVE_LEASE;

        if (isActiveLease && item.tenantId) {
            navigate(`/tenant/${item.tenantId}`);
        } else {
            setIsEditBasicInfo(true);
            setSelectedData(item);
        }

        setOpenActionMenu(null);
    };

    const isNotes = (item) => {
        setIsViewNotes(true);
        setSelectedData(item);
        setOpenActionMenu(null);
    }
    // Helper function to get stage color
    const getStageColor = (stage) => {
        const colors = {
            'Inquiry': 'bg-blue-50 text-blue-700 border-blue-100',
            'Visit Scheduled': 'bg-yellow-50 text-yellow-700 border-yellow-100',
            'Negotiation': 'bg-purple-50 text-purple-700 border-purple-100',
            'Booked': 'bg-green-50 text-green-700 border-green-100',
            'Active Lease': 'bg-teal-50 text-teal-700 border-teal-100', // new
            'Cancelled': 'bg-gray-50 text-gray-700 border-gray-100',
            'Lost': 'bg-red-50 text-red-700 border-red-100',
        };
        return colors[stage] || 'bg-gray-50 text-gray-700 border-gray-100';
    };

    // Helper function to format currency
    const formatCurrency = (amount) => {
        if (!amount) return '₹0';
        return new Intl.NumberFormat('en-IN', {
            style: 'currency',
            currency: 'INR',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
        }).format(amount);
    };

    const storageKey = `deals_page_index_${activeTab}`;
    const [data, setData] = useState([]);
    const [selectedRow, setSelectedRow] = useState(null);
    const [openActionMenu, setOpenActionMenu] = useState(null);
    const [isMobileView, setIsMobileView] = useState(window.innerWidth < 768);

    const toggleRow = (index) => {
        setSelectedRow(selectedRow === index ? null : index);
    };

    const storageValue = sessionStorage.getItem(storageKey);
    const savedPage = storageValue !== null ? Number(storageValue) : 0;
    const [currentPage, setCurrentPage] = useState(savedPage);

    useEffect(() => {
        setCurrentPage(savedPage);
    }, [savedPage]);

    const ActionBtns = (item, tab) => {
        const openMenu = (id) => {
            setOpenActionMenu((prevId) => (prevId === id ? null : id));
        };

        if (!item) return null;

        const renderMenuOptions = () => {
            switch (tab) {
                case "2": // Follow-ups
                    return (
                        <div className="flex items-center gap-3">
                            <Tooltip label="Click to view and add notes">
                                <button
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        isNotes(item);
                                    }}
                                    className="text-gray-400 hover:text-blue-600 transition"
                                >
                                    <FaFileAlt size={16} />
                                </button>
                            </Tooltip>
                            {/* <Tooltip label="Send reminder">
                                <button
                                    //onClick={() => showPaymentModal(item, e)}
                                    className="p-2 rounded-full hover:bg-gray-100 transition cursor-pointer"
                                >
                                    {0 === item.id ? (
                                        <div className="w-4 h-4 border-2 border-gray-300 border-t-transparent rounded-full animate-spin" />
                                    ) : (
                                        <FiBell className="text-gray-400" size={18} />
                                    )}
                                </button>
                            </Tooltip> */}
                            {/* <Tooltip label="Edit Deal">
                                <button
                                    onClick={() => editDeal(item)}
                                    className="p-2 rounded-full hover:bg-gray-100 transition cursor-pointer"
                                >
                                    <MdEdit className="text-gray-400" size={18} />
                                </button>
                            </Tooltip> */}
                        </div>
                    );

                case "3": // Closed Won
                    return (
                        <div className="flex items-center gap-3">
                            <Tooltip label="Click to view and add notes">
                                <button
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        isNotes(item);
                                    }}
                                    className="text-gray-400 hover:text-blue-600 transition"
                                >
                                    <FaFileAlt size={16} />
                                </button>
                            </Tooltip>
                            {/* <Tooltip label="Edit Deal">
                                <button
                                    onClick={() => editDeal(item)}
                                    className="p-2 rounded-full hover:bg-gray-100 transition cursor-pointer"
                                > */}
                            {/* {0 === item.id ? (
                                        <div className="w-4 h-4 border-2 border-gray-300 border-t-transparent rounded-full animate-spin" />
                                    ) : ( */}
                            {/* <FaEdit className="text-gray-400" size={18} /> */}
                            {/* )} */}
                            {/* </button>
                            </Tooltip> */}
                            {/* <Tooltip label="View details">
                                <button
                                    //onClick={() => goToDues("Tenant Info", item)}
                                    className="px-2 ml-auto text-gray-400 hover:text-gray-700 transition"
                                >
                                    <MdOutlineChevronRight size={22} />
                                </button>
                            </Tooltip> */}
                        </div>
                    );

                case "4": // Lost
                    return (
                        <div className="flex items-center gap-3">
                            <Tooltip label="Click to view and add notes">
                                <button
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        isNotes(item);
                                    }}
                                    className="text-gray-400 hover:text-blue-600 transition"
                                >
                                    <FaFileAlt size={16} />
                                </button>
                            </Tooltip>

                        </div>
                    );
                case "5": // Lost
                    return (
                        <div className="flex items-center gap-3">
                            <Tooltip label="Click to view and add notes">
                                <button
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        isNotes(item);
                                    }}
                                    className="text-gray-400 hover:text-blue-600 transition"
                                >
                                    <FaFileAlt size={16} />
                                </button>
                            </Tooltip>

                        </div>
                    );

                default: // Active Deals
                    return (
                        <div className="flex items-center gap-3">
                            <Tooltip label="Click to view and add notes">
                                <button
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        isNotes(item);
                                    }}
                                    className="text-gray-400 hover:text-blue-600 transition bg-gray-50 rounded-full p-1.5"
                                >
                                    <FaFileAlt size={16} />
                                </button>
                            </Tooltip>
                            {/* <Tooltip label="Edit Deal">
                                <button
                                    onClick={() => editDeal(item)}
                                    className="text-gray-400 hover:text-gray-600 transition bg-gray-50 rounded-full p-1.5"
                                >
                                    <MdEdit size={18} />
                                </button>
                            </Tooltip> */}
                        </div>
                    );
            }
        };
        return renderMenuOptions();
    };

    useEffect(() => {
        if (apiData && Array.isArray(apiData)) {
            const tempData = apiData.map((item) => {
                if (!item) return null;

                // Base data object with safe access
                const baseData = {
                    clientName: getClientName(item, activeTab),
                    action: ActionBtns(item, activeTab),
                    original: item
                };

                // Add tab-specific fields
                if (activeTab === "1") { // Follow-ups tab
                    return {
                        ...baseData,
                        inventory: getInventory(item),
                        stage: getStage(item),
                        dealValue: <DealAmount>{formatCurrency(item?.budget || 0)}</DealAmount>,
                        //followupDate: getNextFollowup(item),
                        daysPending: getDaysPending(item),
                    };
                } else if (activeTab === "2") { // Closed Won tab
                    const buyerCommission = Number(item?.buyerCommission || 0);
                    const sellerCommission = Number(item?.sellerCommission || 0);
                    const totalCommission = buyerCommission + sellerCommission;
                    
                    // Commission content
                    const commissionContent = (
                        <CommissionAmount>
                            {formatCurrency(totalCommission)}
                        </CommissionAmount>
                    );

                    const commissionWithTooltip = (buyerCommission || sellerCommission) ? (
                        <Tooltip
                            label={
                                <div className="text-xs leading-5">
                                    <div>Buyer: {formatCurrency(buyerCommission)}</div>
                                    <div>Seller: {formatCurrency(sellerCommission)}</div>
                                    {/* <div className="font-medium text-gray-800">Total: {formatCurrency(totalCommission)}</div> */}
                                </div>
                            }
                        >
                            {commissionContent}
                        </Tooltip>
                    ) : commissionContent;

                    return {
                        ...baseData,
                        inventory: getInventory(item),
                        closedDate: getClosedDate(item),
                        dealValue: <DealAmount>{formatCurrency(item?.budget || 0)}</DealAmount>,
                        commission: commissionWithTooltip,
                        broker: getBroker(item),
                        stage: getStage(item),
                    };
                } 
                else { // 3 Lease End
                    return {
                        ...baseData,
                        inventory: getInventory(item),
                        stage: getStage(item),
                        dealValue: <DealAmount>{formatCurrency(item?.budget || 0)}</DealAmount>,
                        rent: <RentAmount>{formatCurrency(item?.rent || 0)}</RentAmount>,
                        //nextFollowup: getNextFollowup(item),
                        broker: getBroker(item),
                    };
                }
            }).filter(item => item !== null);

            setData(tempData);
        } else {
            setData([]);
        }
    }, [apiData, openActionMenu, activeTab]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                !event.target.closest("#menuOptions") &&
                !event.target.closest(".action-btn")
            ) {
                setOpenActionMenu(null);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const getClientName = (item, activeTab) => {
        if (!item) return <span className="text-gray-400">N/A</span>;

        return (
            <UserImageWrapper
                onClick={() => {
                    if (activeTab === "5") {
                        navigate(`/tenant/${item.tenantId}`);
                    }
                }}
                className={activeTab === "5" ? "cursor-pointer" : ""}
            >
                <div className="flex-row flex">
                    <UserImage src={Images.Avatar} alt={`Avatar`} />
                </div>
                <div className="flex flex-col gap-1">
                    <div className="flex items-center gap-2 group cursor-pointer">
                        <span className="text-gray-600 text-sm font-medium">
                            {item.name ? item.name.charAt(0).toUpperCase() + item.name.slice(1) : 'N/A'}
                        </span>
                        {activeTab !== "5" &&
                            <button
                                onClick={(e) => {
                                    e.stopPropagation();
                                    editBasicInfo(item);
                                }}
                                title="Edit name"
                            >
                                <FiEdit3 size={14} className="text-gray-400 hover:text-primary-color" />
                            </button>
                        }
                    </div>
                    <div className="flex items-center gap-1 text-gray-400 text-xs">
                        <span className="">#{item.mobile || 'N/A'}</span>
                        <button
                            onClick={(e) => {
                                e.stopPropagation();
                                handleCopy(item.mobile)
                            }}
                            className="hover:text-gray-600 transition"
                            title="Copy Number"
                        >
                            <IoCopySharp size={12} />
                        </button>
                    </div>
                </div>
            </UserImageWrapper>
        );
    };

    const getInventory = (item) => {
        if (!item) return <span className="text-gray-400">N/A</span>;

        return (
            <div className="flex flex-col gap-1">
                <Tooltip label={item.inventoryName || ''} >
                    <span className="text-gray-600 text-sm font-medium truncate max-w-[130px]">
                        {item.inventoryName ? item.inventoryName.charAt(0).toUpperCase() + item.inventoryName.slice(1) : 'N/A'}
                    </span>
                </Tooltip>
                <span className="text-gray-400 text-xs">
                    {item.inventoryAddress ? capitalizeFirstLetter(truncateText(item.inventoryAddress, 20)) : 'N/A'}
                </span>

            </div>
        );
    };

    // const stageMap = {
    //     1: "Inquiry",
    //     2: "Visit Scheduled",
    //     3: "Negotiation",
    //     4: "Closed",
    //     5: "Lost"
    // };

    const stageMap = {
        1: "Inquiry",
        2: "Visit Scheduled",
        3: "Negotiation",
        4: "Booked",
        5: "Active Lease",
        6: "Cancelled",
        7: "Lost",
        8: "End Of Lease"
    };

    const getStage = (item) => {
        if (!item) {
            return <span className="text-gray-400 text-sm">N/A</span>;
        }

        const stageName = stageMap[item.status];
        const stageClass = getStageColor(stageName);

        const tenant = item.tenantBudget;
        const owner = item.ownerExpected;

        const gap =
            tenant && owner
                ? Math.abs(owner - tenant)
                : null;

        const stageContent = (
            <span
                className={`inline-flex items-center gap-1.5 text-xs font-semibold px-2.5 py-1 rounded-full border ${stageClass}`}
            >
                <span className="w-1.5 h-1.5 rounded-full bg-current opacity-70" />

                {stageName}

                {stageName === "Negotiation" && gap !== null && (
                    <span className="opacity-70">
                        • ₹{gap}
                    </span>
                )}
            </span>
        );

        // Tooltip only for negotiation
        if (stageName === "Negotiation" && tenant && owner) {
            return (
                <Tooltip
                    label={
                        <div className="text-xs leading-5">
                            <div>Tenant: ₹{tenant}</div>
                            <div>Owner: ₹{owner}</div>
                            <div className="font-medium text-gray-800">Gap: ₹{gap}</div>
                        </div>
                    }
                >
                    {stageContent}
                </Tooltip>
            );
        }

        return stageContent;
    };

    const getNextFollowup = (item) => {
        if (!item || !item.followUpDate) {
            return <span className="text-gray-400 text-sm">-</span>;
        }

        try {
            const followupDate = new Date(item.followUpDate);
            const now = new Date();

            const isToday =
                followupDate.toDateString() === now.toDateString();

            const isTomorrow =
                new Date(now.setDate(now.getDate() + 1)).toDateString() ===
                followupDate.toDateString();

            const isOverdue = followupDate < new Date();

            let style = "bg-gray-50 text-gray-600 border-gray-200";
            let labelPrefix = "";

            if (isOverdue) {
                style = "bg-rose-50 text-rose-600 border-rose-200";
                labelPrefix = "Overdue";
            } else if (isToday) {
                style = "bg-amber-50 text-amber-600 border-amber-200";
                labelPrefix = "Today";
            } else if (isTomorrow) {
                style = "bg-blue-50 text-blue-600 border-blue-200";
                labelPrefix = "Tomorrow";
            }

            return (
                <div className="flex flex-col gap-1">
                    <span
                        className={`inline-flex items-center gap-1.5 text-xs font-semibold px-2.5 py-1 rounded-full border w-fit ${style}`}
                    >
                        {labelPrefix && `${labelPrefix} · `}
                        {followupDate.toLocaleDateString("en-IN", {
                            day: "2-digit",
                            month: "short",
                        })}
                    </span>

                    {/* <span className="text-[11px] text-gray-400">
                        {followupDate.toLocaleTimeString("en-IN", {
                            hour: "2-digit",
                            minute: "2-digit",
                        })}
                    </span> */}
                </div>
            );
        } catch (error) {
            return <span className="text-gray-400 text-sm">Invalid</span>;
        }
    };

    // Follow-ups tab specific functions
    const getDaysPending = (item) => {
        if (!item || !item.followUpDate) {
            return <span className="text-gray-400 text-sm">-</span>;
        }

        try {
            const today = new Date();
            today.setHours(0, 0, 0, 0);

            const followupDate = new Date(item.followUpDate);
            followupDate.setHours(0, 0, 0, 0);

            const diffDays = Math.ceil(
                (followupDate - today) / (1000 * 60 * 60 * 24)
            );

            let label = "";
            let style =
                "bg-gray-50 text-gray-600 border-gray-200"; // default future

            if (diffDays < 0) {
                label = `${Math.abs(diffDays)}d Overdue`;
                style = "bg-rose-50 text-rose-600 border-rose-200";
            } else if (diffDays === 0) {
                label = "Today";
                style = "bg-amber-50 text-amber-600 border-amber-200";
            } else if (diffDays <= 2) {
                label = `${diffDays}d Soon`;
                style = "bg-blue-50 text-blue-600 border-blue-200";
            } else {
                label = `${diffDays}d`;
            }

            return (
                <span
                    className={`text-xs font-semibold px-2.5 py-1 rounded-full border inline-flex items-center ${style}`}
                >
                    {label}
                </span>
            );
        } catch (error) {
            return <span className="text-gray-400 text-sm">-</span>;
        }
    };

    const getNotes = (item) => {
        if (!item) return <span className="text-gray-400">-</span>;

        return (
            <div className="flex flex-col gap-1">
                <span className="text-sm text-gray-600 max-w-[150px] truncate">
                    {item.notes || '-'}
                </span>
            </div>
        );
    };

    const getClosedDate = (item) => {
        if (!item) return <span className="text-gray-400">-</span>;

        return (
            <div className="flex flex-col gap-1">
                <span className="text-sm text-gray-600">
                    {item.followUpDate
                        ? new Date(item.followUpDate).toLocaleDateString("en-IN", {
                            day: "2-digit",
                            month: "short",
                            year: "numeric",
                        })
                        : "-"}
                </span>
            </div>
        );
    };

    const getBroker = (item) => {
        if (!item) return <span className="text-gray-400">-</span>;

        return (
            <div className="flex flex-col gap-1">
                <span className="text-sm text-gray-600">
                    {item.broker || item.assignAgent || '-'}
                </span>
            </div>
        );
    };

    useEffect(() => {
        const handleResize = () => {
            setIsMobileView(window.innerWidth < 768);
        };
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    // Define columns based on active tab
    const columns = React.useMemo(() => {
        if (isMobileView) {
            return [
                {
                    Header: "Client",
                    accessor: "clientName",
                },
                {
                    Header: activeTab === "3" ? "Deal Value" : "Status",
                    accessor: activeTab === "3" ? "dealValue" : "stage",
                },
            ];
        }

        if (activeTab === "1") { // Follow-ups tab
            return [
                { Header: "Client", accessor: "clientName" },
                { Header: "Inventory", accessor: "inventory" },
                { Header: "Deal Value", accessor: "dealValue" },
                { Header: "Stage", accessor: "stage" },
                // { Header: "Follow-up", accessor: "followupDate" },
                // { Header: "Days Pending", accessor: "daysPending" },
                //{ Header: "Notes", accessor: "notes" },
                { Header: "Action", accessor: "action" },
            ];
        } else if (activeTab === "2") { // Closed Won tab
            return [
                { Header: "Client", accessor: "clientName" },
                { Header: "Inventory", accessor: "inventory" },
                { Header: "Deal Value", accessor: "dealValue" },
                { Header: "Stage", accessor: "stage" },
                // { Header: "Commission", accessor: "commission" },
                // { Header: "Booked At", accessor: "closedDate" },
                // { Header: "Broker", accessor: "broker" },
                { Header: "Action", accessor: "action" },
            ];
        }
        else { //3 Active tabs
            return [
                { Header: "Tenant", accessor: "clientName" },
                { Header: "Inventory", accessor: "inventory" },
                { Header: "Deal Value", accessor: "dealValue" },
                { Header: "Stage", accessor: "stage" },
                // { Header: "Follow-up", accessor: "nextFollowup" },
                // { Header: "Assign Agent", accessor: "broker" },
                { Header: "Action", accessor: "action" },
            ];
        }
    }, [isMobileView, activeTab]);

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        prepareRow,
        pageOptions,
        page,
        state: { pageIndex },
        previousPage,
        nextPage,
        canPreviousPage,
        canNextPage,
    } = useTable(
        {
            data,
            columns,
            initialState: { pageIndex: currentPage, pageSize: PaginationLimit },
        },
        useSortBy,
        usePagination
    );

    useEffect(() => {
        setCurrentPage(pageIndex);
    }, [pageIndex]);

    useEffect(() => {
        sessionStorage.setItem(storageKey, pageIndex);
    }, [pageIndex, storageKey]);

    // Simple render for follow-ups tab - no sections, just regular table
    const renderFollowupsTable = () => {
        return page.map((row, rowIndex) => {
            prepareRow(row);
            return (
                <React.Fragment key={rowIndex}>
                    <Tr {...row.getRowProps({ style: { height: "80px" } })} hasdata={(apiData?.length > 0).toString()}>
                        {row.cells.map((cell, cellIndex) => (
                            <Td
                                key={cellIndex}
                                {...cell.getCellProps()}
                                style={cell.column.style}
                                onClick={() => {
                                    if (cellIndex === 0) {
                                        toggleRow(rowIndex);
                                    }
                                }}
                            >
                                {cell.render("Cell")}
                            </Td>
                        ))}
                    </Tr>
                </React.Fragment>
            );
        });
    };

    return (
        <>
            <CustomTable {...getTableProps()}>
                <Thead>
                    {headerGroups.map((headerGroup) => (
                        <Tr {...headerGroup.getHeaderGroupProps()}>
                            {headerGroup.headers.map((column) => (
                                <Th
                                    key={column.id}
                                    {...column.getHeaderProps(column.getSortByToggleProps())}
                                    style={column.style}
                                >
                                    {column.render("Header")}
                                    <span>
                                        {column.isSorted ? (
                                            <img
                                                src={Images.Arrow}
                                                alt="down arrow"
                                                className={`${column.isSortedDesc ? "-rotate-90" : "rotate-90"
                                                    } w-1.5 inline-block ml-1.5`}
                                            />
                                        ) : (
                                            ""
                                        )}
                                    </span>
                                </Th>
                            ))}
                        </Tr>
                    ))}
                </Thead>
                <Tbody {...getTableBodyProps()} hasdata={(apiData?.length > 0).toString()}>
                    {renderFollowupsTable()}
                </Tbody>
            </CustomTable>

            {apiData?.length > 0 && (
                <PaginationWrapper>
                    <div className="px-2">
                        Page{" "}
                        <em>
                            {pageIndex + 1} of {pageOptions.length}
                        </em>
                    </div>
                    <div className="flex gap-1">
                        <PrevBtn onClick={() => previousPage()} disabled={!canPreviousPage}>
                            <img src={Images.Arrow} alt="arrow" className="w-2 opacity-75 " />
                        </PrevBtn>
                        <NextBtn onClick={() => nextPage()} disabled={!canNextPage}>
                            <img
                                src={Images.Arrow}
                                alt="arrow"
                                className="w-2 rotate-180 opacity-75"
                            />
                        </NextBtn>
                    </div>
                </PaginationWrapper>
            )}
            {/* {(!apiData || apiData.length === 0) && <NotFoundModel />} */}
        </>
    );
};

const ActionBtnWrapper = tw.div`flex items-center gap-3 relative`;
const CustomTable = tw.table`w-full text-zinc-600`;
const Thead = tw.thead`border-b uppercase text-gray-600 bg-blue-50`;
const Tbody = tw.tbody`${(props) => (props.hasdata === "true" ? "border-b" : "")}`;
const Tr = tw.tr`${(props) =>
    props.hasdata === "true"
        ? "border-b"
        : ""} rounded-md overflow-hidden hover:bg-slate-50`;
const Th = tw.th`text-left text-sm md:p-3 p-0.5 font-normal text-gray-600`;
const Td = tw.td`p-1 text-sm md:p-2 text-left`;
const UserImageWrapper = tw.div`flex items-center gap-2`;
const MenuOptions = tw.div`
  absolute bottom-10 right-0
  py-2 w-max
  bg-white z-50
  rounded-xl
  shadow-xl
  border border-gray-200
  flex flex-col
`;
const MenuItemCustom = tw.div`flex items-center gap-2 
  px-4 py-2 
  text-sm 
  cursor-pointer 
  hover:bg-gray-50`;

const DealAmount = tw.p`
  text-gray-800 
  text-sm 
  font-semibold 
  bg-neutral-100 
  px-3 
  py-1 
  rounded-full 
  inline-flex 
  min-w-[80px]
  justify-center
`;

const RentAmount = tw.p`
  text-gray-800 
  text-sm 
  font-semibold 
  bg-neutral-100 
  px-3 
  py-1 
  rounded-full 
  inline-flex 
  min-w-[80px]
  justify-center
`;


const CommissionAmount = tw.p`
  text-green-800 
  text-sm 
  font-semibold 
  bg-green-100 
  px-3 
  py-1 
  rounded-full 
  inline-flex 
  min-w-[80px]
  justify-center
`;

export default ClosedTable;